import { AuthLayout, UserSignUpForm } from 'features';
import { safiLogo } from 'features/brand';
import { Trans, useTranslation } from 'i18n';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Link, Typography } from 'ui';

import { getAuthRoute } from '../../utils/getAuthRoute';

export const SignUp = () => {
  const { t } = useTranslation('auth');
  const { t: tCommon } = useTranslation('common');
  const navigate = useNavigate();

  return (
    <AuthLayout
      title={t('shared.marketingTitle')}
      subtitle={t('shared.marketingSubtitle', { values: { brandName: tCommon('brand.name') } })}
      logo={safiLogo}
    >
      <UserSignUpForm
        onSuccess={() => {
          navigate(getAuthRoute('/sign-up/verify'));
        }}
      />
      <Typography variant="body2">
        <Trans
          namespace="auth"
          i18nKey="signUp.alreadyHaveAccount"
          components={{
            signInLink: <Link component={RouterLink} to={getAuthRoute('/sign-in')} />,
          }}
        />
      </Typography>
    </AuthLayout>
  );
};
